$(document).on("turbolinks:load", function () {
  let $myModal = $("#alertModal")
  let $closeButton = $("#alertModalClose")
  let $overlay = $(".overlay-background")
  let $completed = $myModal.data("completed")
  let $loginBefore = $myModal.data("login-before")

  if (!$completed && $loginBefore) {
    $overlay.css("display", "block")
    $myModal.addClass("show")
    $myModal.css("display", "block")
    $myModal.attr("aria-hidden", false)

    if ($myModal.hasClass("show")) {
      document.cookie = "alertModal=completed; path=/"

      $closeButton.on("click", function () {
        $myModal.removeClass("show")
        $myModal.css("display", "none")
        $myModal.attr("aria-hidden", true)
        $overlay.css("display", "none")
      })
    }
  }
})
